import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  Inject,
  forwardRef,
  Input
} from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import {
  DisplayEntityValueDataEntity,
  DataEntity
} from 'src/app/models/data-entities';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-display-entity-value-data-entity-view',
    templateUrl: './display-entity-value-data-entity-view.component.html',
    styleUrls: ['./display-entity-value-data-entity-view.component.css'],
    standalone: false
})
export class DisplayEntityValueDataEntityViewComponent
  extends DataEntityViewComponent
  implements OnInit {
  showEntity = true;

  @Input() entity: DisplayEntityValueDataEntity;
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  testEntity: DisplayEntityValueDataEntity;

  ngOnInit() {
    this.entity.evaluateLabelSource();
    this.showEntity = this.entity.evaluateVisibility();
  }
}
